<div class="map-page">
  <div class="map-page__container">
    <h1 class="map-page__title">Portabilidad</h1>
    <div class="informaciones-page">
  <div class="container">
    <header class="page-header">

    </header>

    <div class="container-options">
  <div class="header-selection">
    <h2>Seleccione el tipo de trámite</h2>
    <p>Haga clic en una de las opciones para continuar con su solicitud.</p>
  </div>

  <div class="options-grid">
    <div class="option-card" (click)="seleccionarOpcion('certificado')">
      <div class="icon-box">
        <img src="https://www.unipay.cl/api/descargaArchivo/web002-carpeta.png" alt="portabilidad">
      </div>
      <div class="option-content">
        <h3>Solicitud de Certificado de Liquidación de Deuda</h3>
        <p>Obtenga el documento oficial de liquidación de deuda Unipay.</p>
      </div>
      <div class="arrow">→</div>
    </div>

    <div class="option-card" (click)="seleccionarOpcion('portabilidad')">
      <div class="icon-box">
        <img src="https://www.unipay.cl/api/descargaArchivo/web002-sistema-de-pago.png" alt="portabilidad">
      </div>
      <div class="option-content">
        <h3>Solicitud de Portabilidad Financiera</h3>
        <p>Inicie el proceso para portar sus productos financieros desde otra institución a Unipay.</p>
      </div>
      <div class="arrow">→</div>
    </div>
  </div>
</div>
  </div>
</div>
  </div>
</div> 
